import React, { Component } from "react";
import styled, { css, keyframes } from "styled-components";
import PropTypes from "prop-types";

import { colors, header } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

import OffCanvasTray from "../OffCanvasTray";
import FilterWinesHolder from "../../molecules/FilterWinesHolder";
import TrayContainer from "../../atoms/TrayContainer";

const sheetApearing = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;

const sheetDisappearing = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(140%);
  }
`;

const StyledBoxTray = styled(TrayContainer)`
  background-color: ${colors.white};
  ${breakpoints.xsUp} {
    width: 500px;
  }
  ${breakpoints.xsDown} {
    width: 100%;
  }
  z-index: 2000;
  ${(props) =>
    !props.isInMyCellar &&
    css`
      max-height: 100%;
    `}
  ${breakpoints.mdUp} {
    top: ${header.desktopHeight};
  }
  ${(props) =>
    !props.isOpened &&
    css`
      display: none;
    `}
  display: flex;
  flex: 1;
  animation: ${(props) => (props.hide ? sheetDisappearing : sheetApearing)};
  animation-duration: 0.4s;
`;

class FilterWinesTray extends Component {
  static propTypes = {
    toggleFilterWines: PropTypes.func.isRequired,
    showPriceRangesFilter: PropTypes.bool,
    showWineColoursFilter: PropTypes.bool,
    showWineProductionMethodsFilter: PropTypes.bool,
    showWineCountriesFilter: PropTypes.bool,
    showWineCuisinesFilter: PropTypes.bool,
    showWineRegionsFilter: PropTypes.bool,
    showWineGrapeTypesFilter: PropTypes.bool,
    showWineAlcoholFilter: PropTypes.bool,
    showWineSweetnessesFilter: PropTypes.bool,
    showWineTanninsFilter: PropTypes.bool,
    showWineBodiesFilter: PropTypes.bool,
    showWineFruitDrivensFilter: PropTypes.bool,
    showWineAciditiesFilter: PropTypes.bool,
    showWineCollectionsFilter: PropTypes.bool,
    showWineOakiesFilter: PropTypes.bool,
    showOrderByFilter: PropTypes.bool,
    onChange: PropTypes.func,
    selectedWinePriceRangeIds: PropTypes.arrayOf(PropTypes.number),
    selectedWineClassIds: PropTypes.arrayOf(PropTypes.number),
    selectedWineProductionMethodIds: PropTypes.arrayOf(PropTypes.number),
    selectedCountryIds: PropTypes.arrayOf(PropTypes.number),
    selectedCuisineIds: PropTypes.arrayOf(PropTypes.number),
    selectedWineRegionIds: PropTypes.arrayOf(PropTypes.number),
    selectedWineTypeIds: PropTypes.arrayOf(PropTypes.number),
    selectedWineAlcoholRange: PropTypes.arrayOf(PropTypes.number),
    selectedWineSweetnessId: PropTypes.number,
    selectedWineTanninId: PropTypes.number,
    selectedWineBodyId: PropTypes.number,
    selectedWineFruitDrivenId: PropTypes.number,
    selectedWineAcidityId: PropTypes.number,
    selectedWineListSlug: PropTypes.string,
    selectedWineOakyId: PropTypes.string,
    selectedOrderBy: PropTypes.string,
    selectedName: PropTypes.string,
    isInMyCellar: PropTypes.bool,
    totalMatchCount: PropTypes.number,
    matchCountData: PropTypes.any,
    matchCountLoading: PropTypes.bool,
  };

  static defaultProps = {
    showPriceRangesFilter: true,
    showWineColoursFilter: true,
    showWineProductionMethodsFilter: true,
    showWineCountriesFilter: true,
    showWineCuisinesFilter: true,
    showWineRegionsFilter: true,
    showWineGrapeTypesFilter: true,
    showWineAlcoholFilter: true,
    showWineSweetnessesFilter: true,
    showWineTanninsFilter: true,
    showWineBodiesFilter: true,
    showWineFruitDrivensFilter: true,
    showWineAciditiesFilter: true,
    showWineCollectionsFilter: true,
    showWineOakiesFilter: true,
    showOrderByFilter: true,
    onChange: () => {},
    selectedWinePriceRangeIds: [],
    selectedWineClassIds: [],
    selectedWineProductionMethodIds: [],
    selectedCountryIds: [],
    selectedCuisineIds: [],
    selectedWineRegionIds: [],
    selectedWineTypeIds: [],
    selectedWineAlcoholRange: [],
    selectedWineSweetnessId: undefined,
    selectedWineTanninId: undefined,
    selectedWineBodyId: undefined,
    selectedWineFruitDrivenId: undefined,
    selectedWineAcidityId: undefined,
    selectedWineListSlug: undefined,
    selectedWineOakyId: undefined,
    selectedOrderBy: undefined,
    selectedName: "",
    isInMyCellar: false,
    totalMatchCount: undefined,
    matchCountData: undefined,
    matchCountLoading: false,
  };

  state = {
    hide: false,
  };

  /**
   * this function sets the state of hide to true,
   * so, the hiding action can start animating,
   * then, close the tray after 200ms.
   * */
  handleCloseTray = () => {
    this.setState({ hide: true });
    const { toggleFilterWines } = this.props;
    setTimeout(() => toggleFilterWines(), 200);
  };

  render() {
    const {
      showPriceRangesFilter,
      showWineColoursFilter,
      showWineProductionMethodsFilter,
      showWineCountriesFilter,
      showWineCuisinesFilter,
      showWineRegionsFilter,
      showWineGrapeTypesFilter,
      showWineAlcoholFilter,
      showWineSweetnessesFilter,
      showWineTanninsFilter,
      showWineBodiesFilter,
      showWineFruitDrivensFilter,
      showWineAciditiesFilter,
      showWineCollectionsFilter,
      showWineOakiesFilter,
      showOrderByFilter,
      onChange,
      selectedWinePriceRangeIds,
      selectedWineClassIds,
      selectedWineProductionMethodIds,
      selectedCountryIds,
      selectedCuisineIds,
      selectedWineRegionIds,
      selectedWineTypeIds,
      selectedWineAlcoholRange,
      selectedWineSweetnessId,
      selectedWineTanninId,
      selectedWineBodyId,
      selectedWineFruitDrivenId,
      selectedWineAcidityId,
      selectedWineListSlug,
      selectedWineOakyId,
      selectedOrderBy,
      selectedName,
      isInMyCellar,
      totalMatchCount,
      matchCountData,
      matchCountLoading,
    } = this.props;

    const { hide } = this.state;

    return (
      <OffCanvasTray setOverflowHidden={false} isOffcanvasOpened outSideClickHandler={this.handleCloseTray}>
        <StyledBoxTray isOpened hide={hide} isInMyCellar={isInMyCellar}>
          <FilterWinesHolder
            showPriceRangesFilter={showPriceRangesFilter}
            showWineColoursFilter={showWineColoursFilter}
            showWineProductionMethodsFilter={showWineProductionMethodsFilter}
            showWineCountriesFilter={showWineCountriesFilter}
            showWineCuisinesFilter={showWineCuisinesFilter}
            showWineRegionsFilter={showWineRegionsFilter}
            showWineGrapeTypesFilter={showWineGrapeTypesFilter}
            showWineAlcoholFilter={showWineAlcoholFilter}
            showWineSweetnessesFilter={showWineSweetnessesFilter}
            showWineTanninsFilter={showWineTanninsFilter}
            showWineBodiesFilter={showWineBodiesFilter}
            showWineFruitDrivensFilter={showWineFruitDrivensFilter}
            showWineAciditiesFilter={showWineAciditiesFilter}
            showWineCollectionsFilter={showWineCollectionsFilter}
            showWineOakiesFilter={showWineOakiesFilter}
            showOrderByFilter={showOrderByFilter}
            onChange={onChange}
            filterWinesIsOpen
            toggleFilterWines={() => this.handleCloseTray()}
            selectedWinePriceRangeIds={selectedWinePriceRangeIds}
            selectedWineClassIds={selectedWineClassIds}
            selectedWineProductionMethodIds={selectedWineProductionMethodIds}
            selectedCountryIds={selectedCountryIds}
            selectedCuisineIds={selectedCuisineIds}
            selectedWineRegionIds={selectedWineRegionIds}
            selectedWineTypeIds={selectedWineTypeIds}
            selectedWineAlcoholRange={selectedWineAlcoholRange}
            selectedWineSweetnessId={selectedWineSweetnessId}
            selectedWineTanninId={selectedWineTanninId}
            selectedWineBodyId={selectedWineBodyId}
            selectedWineFruitDrivenId={selectedWineFruitDrivenId}
            selectedWineAcidityId={selectedWineAcidityId}
            selectedWineListSlug={selectedWineListSlug}
            selectedWineOakyId={selectedWineOakyId}
            selectedOrderBy={selectedOrderBy}
            isInMyCellar={isInMyCellar}
            selectedName={selectedName}
            matchCountData={matchCountData}
            totalMatchCount={totalMatchCount}
            matchCountLoading={matchCountLoading}
          />
        </StyledBoxTray>
      </OffCanvasTray>
    );
  }
}

export default FilterWinesTray;
